import { Entity, IEntity } from '@lycoris-nubila/ngx-lycoris';

export interface IUserMood extends IEntity {
	readonly mood: number;
	readonly feelings: string;
}

export class UserMood extends Entity implements IUserMood {
	private _mood: number;
	private _feelings: string;

	constructor(
		id: string,
		creationTimestamp: number,
		mood: number,
		feelings: string
	) {
		super(id, creationTimestamp);
		this._mood = mood;
		this._feelings = feelings;
	}

	public get mood(): number {
		return this._mood;
	}

	public get feelings(): string {
		return this._feelings;
	}
}
